import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { animated } from 'react-spring';
import { Link } from 'gatsby';
import Img from 'gatsby-image';

import CurrencyFormat from './CurrencyFormat';
import DummyImage from './DummyImage';

const Container = styled(animated.div)`
  .gatsby-image-wrapper {
    @media screen and (max-width: 769px) {
      overflow: visible !important;
    }
  }
  img {
    object-fit: cover;
  }

  .card {
    border: none;
    box-shadow: none;

    :hover {
      border-radius: 0px;
      z-index: 2;
      box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
      background-color: #fff;
      transition: 1s;
    }
  }
  .card-content {
    padding: 1rem 0;
  }
  .card-image {
    overflow: hidden;
  }
  span {
    margin: 0 0 0 16px;
    text-decoration: line-through;
    color: ${(props) => props.theme.textColorExtraLite} !important;
  }
`;

const Image = styled(Img)`
  object-fit: cover;
`;

const ProductItem = ({ item, styles }) => {
  const variant = item.otherVariants[0];
  return (
    <Container
      className="column is-one-quarter-desktop is-6-mobile"
      style={styles}
    >
      <div className="card">
        <Link to={`/product/${item.slug.current}`}>
          <div className="card-image">
            {variant && variant.featuredImage ? (
              <Image fluid={variant.featuredImage.asset.fluid} />
            ) : (
              <DummyImage />
            )}
          </div>
        </Link>
        <div className="card-content">
          <div className="media">
            <div className="media-content">
              <p className="subtitle is-6 has-text-centered has-text-black has-text-weight-semibold">
                <Link to={`/product/${item.slug.current}`}>{item.title}</Link>
              </p>
              <p className="title is-6 has-text-centered has-text-warning-light is-family-secondary">
                <CurrencyFormat pricing={variant.pricing} isDiscount />
                <span className="has-text-weight-bold">
                  <CurrencyFormat pricing={variant.pricing} />
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

ProductItem.propTypes = {
  styles: PropTypes.object.isRequired,
};

export default ProductItem;
